import type { ReactNode } from 'react';

export function Anchor(props: { tag: string; children: ReactNode }) {
  return (
    <div className="anchor-container relative">
      <span className="anchor absolute bottom-full" id={props.tag} />
      {props.children}
    </div>
  );
}
